import React, { useState } from "react";
import CommonModal from "../../ResetContext/components/DumpModal";
import { AlertTriangle, Loader2 } from "lucide-react";
import InputField from "../../ResetContext/components/InputField";
import Alert from "../../ResetContext/components/Alert";
import { Button } from "components/ui/button";
import { useCancelSubscription } from "../../../../../queries/billing";
import { useUserInfo } from "../../../../../context/user";

const CancelConfirmModal = ({ isOpen, onClose }) => {
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const saveActiveLocation = useUserInfo()[5];
  const { mutateAsync: cancelSubscription } = useCancelSubscription(userActiveLocation?.id);

  const onConfirm = async () => {
    setLoading(true);
    try {
      const response = await cancelSubscription({
        subscription_id: userActiveLocation?.subscription_id,
        agency_id: userActiveLocation?.agency_id,
        account_id: userActiveLocation?._id,
      });
      if (response?.success) {
        setLoading(false);
        saveActiveLocation(response?.account);
        onClose();
        return;
      }
    } catch (err) {
      // fall through to the generic alert below
    }
    setLoading(false);
    alert("Something went wrong, please try again later.");
  };
  return (
    <CommonModal title={""} isOpen={isOpen} onClose={onClose} showAlert={false}>
      <h4 className="text-xl font-semibold text-center mb-2">
        Cancel Your Plan
      </h4>
      <Alert
        icon={<AlertTriangle className="text-foreground" />}
        text="You're about to cancel your plan. This action is permanent and cannot be
        undone."
        type="danger"
      />
      <div className="mt-4">
        <label htmlFor="confirm" className="text-muted-foreground text-md">
          Type CONFIRM to proceed
        </label>
        <InputField
          id="confirm"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={"Type CONFIRM to proceed"}
          classNames={"mt-2 focus:!border-border"}
        />
        <Button
          variant="destructive"
          className="mt-4 w-full py-3 text-lg h-auto"
          onClick={onConfirm}
          disabled={loading || input !== "CONFIRM"}
        >
          {loading ? (
            <Loader2 className="animate-spin" />
          ) : (
            "Cancel plan"
          )}
        </Button>
      </div>
    </CommonModal>
  );
};

export default CancelConfirmModal;
